import React from "react";
import PropTypes from "prop-types";
import { useFormikContext, getIn } from "formik";
import {
  GroupField,
  ArrayField,
  FieldLabel,
  NumberInput,
} from "react-invenio-forms";
import { Button, Form, Icon } from "semantic-ui-react";
import { CustomArrayField } from "./CustomArrayField";

const MultilineIntegerInput = ({
  fieldPath,
  label,
  placeholder,
  description,
  additionLabel,
  icon,
  required,
}) => {
  const { values } = useFormikContext();

  const getValueForLine = (indexPath) => {
    const currentValue = getIn(values, fieldPath, []);
    return currentValue[indexPath] ?? "";
  };

  return (
    <>
      <CustomArrayField
        addButtonLabel={additionLabel || "Add Number"}
        defaultNewValue=""
        fieldPath={fieldPath}
        label={<FieldLabel htmlFor={fieldPath} icon={icon} label={label} />}
        required={required}
      >
        {({ arrayHelpers, indexPath }) => {
          const fieldPathPrefix = `${fieldPath}.${indexPath}`;
          const lineValue = getValueForLine(indexPath);

          return (
            <GroupField key={fieldPathPrefix} optimized>
              <NumberInput
                fieldPath={fieldPathPrefix}
                label=""
                required={required}
                placeholder={placeholder}
                value={lineValue}
                width={16}
              />
              <Form.Field>
                <Button
                  aria-label="Remove line"
                  className="close-btn multiline-number-field"
                  icon
                  onClick={() => arrayHelpers.remove(indexPath)}
                >
                  <Icon name="close" />
                </Button>
              </Form.Field>
            </GroupField>
          );
        }}
      </CustomArrayField>

      {description && <label className="helptext">{description}</label>}
    </>
  );
};

MultilineIntegerInput.propTypes = {
  fieldPath: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  description: PropTypes.string,
  additionLabel: PropTypes.string,
  icon: PropTypes.string,
  required: PropTypes.bool,
};

MultilineIntegerInput.defaultProps = {
  additionLabel: "Add Number",
  icon: undefined,
  required: false,
  description: undefined,
};

export default MultilineIntegerInput;
